/* BeanBurds Coffee PDP — product template v1 (coffee consumables).
   Ported from BeanBurds-PDP-Coffee-v1.html.

   Differences from the design file, all deliberate:
   - The demo's own header / search row / menu drawer / cart drawer are NOT ported.
     The theme already owns those. Only PDP-local behaviour lives here.
   - Add-to-cart posts to the real /cart/add.js with selling_plan, instead of the
     demo's in-memory Map.
   - No GA4 add_to_cart event is fired. The Tinker parent theme already fires one on
     any /cart/add.js and a second would double-count. (BeanBurds-Project-Update §3.)

   All data comes from the JSON blob in #bbp-data, emitted by sections/bb-pdp-coffee.liquid.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-bbp-root]');
  if (!root) return;

  var dataEl = document.getElementById('bbp-data');
  if (!dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var VARIANTS = DATA.variants || [];
  var PLANS = DATA.sellingPlans || [];
  var MONEY_FMT = DATA.moneyFormat || 'AED {{amount}}';
  var FREE_SHIP = DATA.freeShippingThreshold || 300;

  var $ = function (id) { return root.querySelector('#' + id); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* ---------- money ---------- */
  function money(cents) {
    var v = cents / 100;
    var s = (Math.round(v * 100) % 100 === 0) ? String(Math.round(v)) : v.toFixed(2);
    return MONEY_FMT.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  /* ---------- state ---------- */
  var state = {
    size: DATA.initialSize,
    grind: DATA.initialGrind,
    plan: 'once',
    planId: PLANS.length ? String(PLANS[0].id) : null,
    qty: 1
  };

  function currentPlan() {
    for (var i = 0; i < PLANS.length; i++) {
      if (String(PLANS[i].id) === String(state.planId)) return PLANS[i];
    }
    return PLANS[0] || { pct: 0, name: '' };
  }

  /* Match on the option values actually selected, so this works no matter which
     option position the merchant assigned to Size / Grind. */
  function currentVariant() {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (String(v.size) === String(state.size) && String(v.grind) === String(state.grind)) return v;
    }
    // Grind may not be a real Shopify option on every product; fall back to size only.
    for (var j = 0; j < VARIANTS.length; j++) {
      if (String(VARIANTS[j].size) === String(state.size)) return VARIANTS[j];
    }
    return VARIANTS[0];
  }

  function oncePrice() { var v = currentVariant(); return v ? v.price : 0; }

  /* Prefer the real selling-plan allocation price from Shopify. Only fall back to
     computing the discount when the plan carries no allocation for this variant. */
  function subPrice() {
    var v = currentVariant();
    if (v && v.planPrices && v.planPrices[state.planId] != null) return v.planPrices[state.planId];
    return Math.round(oncePrice() * (100 - currentPlan().pct) / 100);
  }

  function unitPrice() { return state.plan === 'sub' ? subPrice() : oncePrice(); }

  /* ---------- price + label sync (item 16: live price on the button) ---------- */
  function setText(id, txt) { var el = $(id); if (el) el.textContent = txt; }

  function update() {
    var v = currentVariant();
    var u = unitPrice();
    var plan = currentPlan();

    setText('bbPrice', money(u));

    var bnpl = $('bbBnpl');
    if (bnpl) bnpl.innerHTML = 'or 4 payments of <b>' + money(u / 4) + '</b> with tabby or tamara';

    setText('oncePrice', money(oncePrice()));
    setText('subPrice', money(subPrice()));
    setText('planSave', 'Save ' + plan.pct + '%');
    setText('sizePicked', v ? v.sizeLabel : '');
    setText('qtyVal', state.qty);

    var atc = $('atcBtn');
    var soldOut = v && v.available === false;
    if (atc) {
      atc.disabled = !!soldOut;
      atc.textContent = soldOut
        ? 'Sold out'
        : (state.plan === 'sub'
            ? 'Subscribe — ' + money(u * state.qty) + ' / delivery'
            : 'Add to bag — ' + money(u * state.qty));
    }

    var sticky = $('stickyBtn');
    if (sticky) { sticky.disabled = !!soldOut; sticky.textContent = soldOut ? 'Sold out' : 'Add to bag'; }

    setText('stickyMeta', (v ? v.sizeLabel : '') + ' · ' + state.grind + ' · ' + money(u) +
      (state.plan === 'sub' ? ' / delivery' : ''));

    // Keep the URL's ?variant= in step so refresh/share preserves the selection.
    if (v && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
  }

  /* ---------- variant pickers ---------- */
  function pickerHandler(containerId, attr, key) {
    var c = $(containerId);
    if (!c) return;
    c.addEventListener('click', function (e) {
      var b = e.target.closest('[data-' + attr + ']');
      if (!b) return;
      state[key] = b.getAttribute('data-' + attr);
      c.querySelectorAll('.vbtn').forEach(function (x) { x.classList.toggle('selected', x === b); });
      update();
    });
  }
  pickerHandler('sizeBtns', 'size', 'size');
  pickerHandler('grindBtns', 'grind', 'grind');

  var planBtns = $('planBtns');
  if (planBtns) {
    planBtns.addEventListener('click', function (e) {
      var b = e.target.closest('[data-plan]');
      if (!b) return;
      state.plan = b.getAttribute('data-plan');
      planBtns.querySelectorAll('.plan').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('selected', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var extra = $('planExtra');
      if (extra) extra.classList.toggle('open', state.plan === 'sub');
      update();
    });
  }

  var freq = $('freq');
  if (freq) freq.addEventListener('change', function (e) { state.planId = e.target.value; update(); });

  var qi = $('qtyInc'), qd = $('qtyDec');
  if (qi) qi.addEventListener('click', function () { state.qty = Math.min(9, state.qty + 1); update(); });
  if (qd) qd.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); update(); });

  /* ---------- gallery (item 17-20) ---------- */
  var thumbs = root.querySelector('.g-thumbs');
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.g-thumb');
      if (!b) return;
      var idx = b.getAttribute('data-slot');
      thumbs.querySelectorAll('.g-thumb').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('active', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      $$('[data-slot-panel]').forEach(function (p) {
        var on = p.getAttribute('data-slot-panel') === idx;
        p.hidden = !on;
        // Only start the video once its panel is actually shown.
        if (!on) {
          var f = p.querySelector('iframe[data-src]');
          if (f && f.src) f.removeAttribute('src');
        } else {
          var fr = p.querySelector('iframe[data-src]');
          if (fr && !fr.src) fr.src = fr.getAttribute('data-src');
        }
      });
    });
  }

  /* ---------- overlays: calculator + grind guide (items 13, 24) ---------- */
  var openOverlay = null, lastTrigger = null, savedScroll = 0;
  var backdrop = $('bbpBackdrop');

  function lockBody() {
    savedScroll = window.scrollY;
    document.body.style.top = '-' + savedScroll + 'px';
    document.body.classList.add('bbp-locked');
  }
  function unlockBody() {
    document.body.classList.remove('bbp-locked');
    document.body.style.top = '';
    window.scrollTo({ top: savedScroll, behavior: 'instant' });
  }
  function openDrawer(el, trigger) {
    if (!el) return;
    if (openOverlay) closeOverlay(false);
    openOverlay = el;
    lastTrigger = trigger || null;
    if (backdrop) backdrop.classList.add('open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('open'); }); });
    lockBody();
    var c = el.querySelector('.drawer-close,[data-bbp-close]');
    if (c) c.focus();
  }
  function closeOverlay(restore) {
    if (!openOverlay) return;
    openOverlay.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    unlockBody();
    if (restore !== false && lastTrigger) lastTrigger.focus();
    openOverlay = null;
  }
  if (backdrop) backdrop.addEventListener('click', function () { closeOverlay(); });
  $$('[data-bbp-close]').forEach(function (b) { b.addEventListener('click', function () { closeOverlay(); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOverlay(); });

  var openCalc = $('openCalc'), openGrind = $('openGrind');
  if (openCalc) openCalc.addEventListener('click', function (e) { e.preventDefault(); openDrawer($('calcSheet'), e.currentTarget); });
  if (openGrind) openGrind.addEventListener('click', function (e) { e.preventDefault(); openDrawer($('grindSheet'), e.currentTarget); });

  /* ---------- coffee calculator ---------- */
  var CALC = {
    v60:      { perCup: 250, unit: '250 ml each',   cupsLabel: 'Cups',    ratios: { light: 17,  med: 16,  strong: 15 }, temp: '94°C',        time: '2:45–3:15',  grind: 'medium-fine' },
    espresso: { perCup: 40,  unit: '40 g double shot', cupsLabel: 'Shots', ratios: { light: 2.4, med: 2.2, strong: 2  }, temp: '94°C',        time: '26–30 s',    grind: 'fine' },
    press:    { perCup: 250, unit: '250 ml each',   cupsLabel: 'Cups',    ratios: { light: 16,  med: 15,  strong: 14 }, temp: '95°C',        time: '4:00 steep', grind: 'coarse' },
    cold:     { perCup: 200, unit: '200 ml glass',  cupsLabel: 'Glasses', ratios: { light: 10,  med: 8,   strong: 6  }, temp: 'Room / cold', time: '12–18 h',    grind: 'extra coarse' }
  };
  var calcState = { m: 'v60', s: 'med', cups: 2 };

  function calcPaint() {
    var c = CALC[calcState.m];
    var water = c.perCup * calcState.cups;
    var coffee = Math.round(water / c.ratios[calcState.s]);
    setText('outCoffee', coffee + ' g');
    setText('outWater', calcState.m === 'espresso' ? water + ' g out' : water + ' g');
    setText('outTemp', c.temp);
    setText('outTime', c.time);
    setText('outGrind', c.grind);
    setText('cupHint', c.unit);
    setText('cupsLabel', c.cupsLabel);
    setText('cupVal', calcState.cups);
  }
  function calcPicker(containerId, attr, key) {
    var c = $(containerId);
    if (!c) return;
    c.addEventListener('click', function (e) {
      var b = e.target.closest('[data-' + attr + ']');
      if (!b) return;
      calcState[key] = b.getAttribute('data-' + attr);
      c.querySelectorAll('.vbtn').forEach(function (x) { x.classList.toggle('selected', x === b); });
      calcPaint();
    });
  }
  calcPicker('calcMethods', 'm', 'm');
  calcPicker('calcStrength', 's', 's');
  var ci = $('cupInc'), cd = $('cupDec');
  if (ci) ci.addEventListener('click', function () { calcState.cups = Math.min(8, calcState.cups + 1); calcPaint(); });
  if (cd) cd.addEventListener('click', function () { calcState.cups = Math.max(1, calcState.cups - 1); calcPaint(); });
  if ($('outCoffee')) calcPaint();

  /* ---------- add to cart (real Shopify) ---------- */
  function toast(msg) {
    var t = $('bbpToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  function addToCart() {
    var v = currentVariant();
    if (!v || v.available === false) return;

    var payload = { id: v.id, quantity: state.qty };
    if (state.plan === 'sub' && state.planId) payload.selling_plan = Number(state.planId);
    // Grind is a real variant option when the product has one; when it doesn't,
    // pass it as a line-item property so the roaster still sees the request.
    if (!v.grindIsOption) payload.properties = { Grind: state.grind };

    var btns = [$('atcBtn'), $('stickyBtn')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description || 'Could not add to bag');
        // NOTE: no GA4 add_to_cart here — the parent theme already fires one.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { source: 'bb-pdp' } }));
        toast(DATA.productTitle + ' added to your bag.');
      })
      .catch(function (err) { toast(err.message || 'Something went wrong — please try again.'); })
      .finally(function () { btns.forEach(function (b) { b.disabled = false; }); update(); });
  }

  var atcBtn = $('atcBtn'), stickyBtn = $('stickyBtn');
  if (atcBtn) atcBtn.addEventListener('click', addToCart);
  if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

  /* ---------- sticky mobile ATC ---------- */
  var sticky = $('stickyAtc');
  if (sticky && atcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(atcBtn);
  }

  update();
})();
